import AppShell from '@/components/AppShell'
import { useParams } from 'react-router-dom'
import { get } from '@/lib/storage'

type Line = { id:string; desc:string; tons:number; pricePerTon:number; logging?:number; trucking?:number; other?:number }
type Settlement = { id:string; name:string; customer?:string; mill?:string; job?:string; period?:string; lines:Line[] }

export default function SettlementPrintView(){
  const { id } = useParams()
  const all = get<Settlement[]>('settlements', [])
  const s = all.find(x=>x.id===id)
  if (!s) return <AppShell title="Settlement"><div className="text-sm text-slate-600">Not found.</div></AppShell>

  const revenue = s.lines.reduce((acc,l)=> acc + l.tons*l.pricePerTon, 0)
  const expenses = s.lines.reduce((acc,l)=> acc + l.tons*((l.logging||0)+(l.trucking||0)+(l.other||0)), 0)
  const profit = revenue - expenses

  return (
    <AppShell title={`Settlement • ${s.name}`}>
      <div className="print-area grid gap-4">
        <div className="card">
          <div className="card-header">Summary</div>
          <div className="card-body grid grid-cols-2 md:grid-cols-4 gap-2">
            <Meta k="Name" v={s.name}/>
            <Meta k="Customer" v={s.customer}/>
            <Meta k="Mill" v={s.mill}/>
            <Meta k="Job" v={s.job}/>
            <Meta k="Period" v={s.period}/>
            <Meta k="Revenue" v={`$${revenue.toFixed(2)}`}/>
            <Meta k="Expenses" v={`$${expenses.toFixed(2)}`}/>
            <Meta k="Profit" v={`$${profit.toFixed(2)}`}/>
          </div>
        </div>

        <div className="card">
          <div className="card-header">Lines</div>
          <div className="card-body overflow-x-auto">
            <table className="table">
              <thead>
                <tr><th>Desc</th><th>Tons</th><th>$ / ton</th><th>Revenue</th><th>Log</th><th>Truck</th><th>Other</th></tr>
              </thead>
              <tbody>
                {s.lines.map(l=>(
                  <tr key={l.id}>
                    <td>{l.desc}</td>
                    <td>{l.tons}</td>
                    <td>{l.pricePerTon}</td>
                    <td>{(l.tons*l.pricePerTon).toFixed(2)}</td>
                    <td>{l.logging||0}</td>
                    <td>{l.trucking||0}</td>
                    <td>{l.other||0}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="no-print mt-3"><button className="btn-secondary" onClick={()=>window.print()}>Print</button></div>
          </div>
        </div>
      </div>
    </AppShell>
  )
}

function Meta({k,v}:{k:string; v:any}){
  return (
    <div>
      <div className="text-xs text-slate-500">{k}</div>
      <div>{v ?? '-'}</div>
    </div>
  )
}
